const IconRemove = ({ className }) => {
    return (
        <svg
            width='36'
            height='36'
            viewBox='0 0 36 36'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M18 6C11.3726 6 6 11.3726 6 18C6 24.6274 11.3726 30 18 30C24.6274 30 30 24.6274 30 18C30 11.3726 24.6274 6 18 6ZM3 18C3 9.71573 9.71573 3 18 3C26.2843 3 33 9.71573 33 18C33 26.2843 26.2843 33 18 33C9.71573 33 3 26.2843 3 18ZM12 18C12 17.1716 12.6716 16.5 13.5 16.5H22.5C23.3284 16.5 24 17.1716 24 18C24 18.8284 23.3284 19.5 22.5 19.5H13.5C12.6716 19.5 12 18.8284 12 18Z'
            />
        </svg>
    );
};

export default IconRemove;
